import React from "react";
import styles from "./detailBloodStationEvents.module.scss";
import { useEventStore } from "../../event/store";
import CustomCarousel from "../../ui/customCarousel";
import Spinner from "../../spinner";
import MainEventCard from "../../mainEventCard";

const DetailBloodStationEvents = () => {
  const { bloodStationEvents, bloodStationEventsLoading } = useEventStore();

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1200 },
      items: 1,
      slidesToSlide: 1,
    },
    desktop: {
      breakpoint: { max: 1200, min: 1024 },
      items: 1,
      slidesToSlide: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 767 },
      items: 1,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 766, min: 375 },
      items: 1,
      slidesToSlide: 1,
    },
    little_mobile: {
      breakpoint: { max: 374, min: 320 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  if (bloodStationEventsLoading) return <Spinner toggled={true} />;

  if (!bloodStationEvents.length) return null;

  return (
    <div className={styles.DetailBloodStationEvents}>
      <div className={styles.DetailBloodStationEvents_Title}>
        <h3>Мероприятия</h3>
      </div>
      <div>
        <CustomCarousel
          responsive={responsive}
          partialVisible={false}
          draggable={true}
          swipeable={true}
          arrows={true}
          infinite={true}
          dots={true}
          removeArrowOnDeviceType={["mobile"]}
        >
          {bloodStationEvents.map((event) => (
            <div style={{ margin: "8px 8px 8px 0" }} key={event.id}>
              <MainEventCard event={event} />
            </div>
          ))}
        </CustomCarousel>
      </div>
    </div>
  );
};

export default DetailBloodStationEvents;
